var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgStar(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "icon24",
    xmlns: "http://www.w3.org/2000/svg",
    width: "24px",
    height: "24px",
    viewBox: "0 0 36.31 36.31",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M19.5 3.16l4.31 8.72 9.63 1.41c0.82,0.12 1.39,0.88 1.27,1.71 -0.06,0.37 -0.24,0.69 -0.5,0.91l-6.91 6.73 1.65 9.59c0.14,0.82 -0.41,1.6 -1.23,1.73 -0.36,0.07 -0.72,-0.01 -1.01,-0.18l-8.56 -4.5 -8.61 4.53c-0.73,0.39 -1.64,0.11 -2.03,-0.63 -0.16,-0.3 -0.2,-0.64 -0.15,-0.95l1.64 -9.59 -6.96 -6.78c-0.59,-0.58 -0.61,-1.53 -0.03,-2.13 0.24,-0.24 0.54,-0.39 0.86,-0.44l9.63 -1.41 4.31 -8.72c0.36,-0.74 1.26,-1.05 2.01,-0.68 0.31,0.15 0.54,0.4 0.68,0.68zm1.96 10.76l-3.31 -6.7 -3.27 6.64c-0.2,0.46 -0.63,0.81 -1.16,0.89l-7.4 1.08 5.29 5.15c0.38,0.33 0.58,0.85 0.49,1.39l-1.26 7.36 6.61 -3.47c0.43,-0.23 0.95,-0.24 1.4,-0.01l6.62 3.48 -1.27 -7.36c-0.07,-0.47 0.07,-0.97 0.44,-1.33l5.35 -5.21 -7.4 -1.08c-0.47,-0.07 -0.9,-0.37 -1.13,-0.83z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgStar);
export default __webpack_public_path__ + "static/media/star.beb28f44b6ab0505d14763546b5ec2d8.svg";
export { ForwardRef as ReactComponent };